import React, { Fragment, useRef, useEffect } from 'react'
import classNames from 'classnames'
import gridClasses from '../../styles/grid.module.css'
import { Header } from '../../components/Header/Header'
import {
    Hero,
    HeroBackground,
    HeroContent,
    HeroTitle,
    HeroSubtitle,
} from '../../components/Hero/Hero'
import { Button, ButtonIcon } from '../../components/Button/Button'
import { ReactComponent as ForwardIcon } from '../../assets/icons/forward.svg'
import { Link } from 'react-router-dom'
import { BlogPostCard } from '../../components/Cards/GeneralCard/Card'
import Footer from '../../components/Footer/Footer'
import { ReactComponent as LeftIcon } from '../../assets/icons/arrow-left.svg'
import { ReactComponent as RightIcon } from '../../assets/icons/arrow-right.svg'
import Carousel from '../../components/Carousel/Carousel'
import ourStoryImage from '../../assets/images/our-story.jpg'
import { IndividualPlans } from '../../components/Plans/IndividualPlans'
import OurCourses from '../../components/OurCourses/OurCourses'
import OurClasses from '../../components/OurClasses/OurClasses'
import { useDispatch, useSelector } from 'react-redux'
import { homepageSelectors } from './homepageSlice'
import { getBlogPosts } from './homepageApi'
import notification from '../../components/Notification/notification'
import CardLoader from '../../components/loaders/CardLoader'
import classes from './Unauthenticated.module.css'
import heroImage from '../../assets/images/homepage-hero-new.jpg'
import { useHistory } from 'react-router-dom'
import Doodle from '../../assets/images/doodle.jpg'
import GettingStarted from '../../assets/images/getting-started.jpg'

const PlanSection = () => {
    return (
        <div
            className={classNames(
                classes.infoSection,
                classes.infoSectionCentered
            )}
        >
            <img
                className={classes.subscriptionCardDots}
                src={require('../../assets/images/homepage-dots.svg')}
                alt=""
            />
            <h1
                className={classNames(
                    classes.infoSectionTitle,
                    classes.infoSectionTitleDecorated
                )}
            >
                Click here to choose a plan.
            </h1>
            <p className={classes.infoSectionSubtitle}>
                SME Upturn is your one stop shop to help you grow your
            </p>
            <IndividualPlans />
        </div>
    )
}

export const UnauthenticatedHomepage = () => {
    const prevButton = useRef()
    const nextButton = useRef()

    const posts = useSelector(homepageSelectors.posts)
    const isFetching = useSelector(homepageSelectors.isFetching)
    const hasError = useSelector(homepageSelectors.hasError)
    const history = useHistory()

    const dispatch = useDispatch()

    useEffect(() => {
        dispatch(getBlogPosts())
    }, [])

    useEffect(() => {
        if (hasError) {
            notification.failure({
                title: 'Something went wrong while fetching our classes',
            })
        }
    }, [hasError])

    return (
        <Fragment>
            <Hero
                header={<Header largeLogo />}
                background={<HeroBackground src={heroImage} color="#333" />}
            >
                <HeroContent leftAligned>
                    <HeroTitle>
                        A Business Process-Driven Learning Platform
                    </HeroTitle>
                    <HeroSubtitle>
                        Fast-track the implementation of your business processes
                        with all the tools you need.
                    </HeroSubtitle>
                    <Button
                        uppercase
                        style={{ marginTop: 49, width: 'fit-content' }}
                        to={'/app/browse/courses'}
                    >
                        Start Now
                        <ButtonIcon icon={<ForwardIcon />} />
                    </Button>
                </HeroContent>
            </Hero>
            <main className={classes.main}>
                <div
                    className={classNames(
                        gridClasses.container,
                        classes.pageContent
                    )}
                >
                    <div
                        className={classNames(
                            classes.infoSection,
                            classes.infoSectionDual
                        )}
                    >
                        <div className={classes.infoSectionPane}>
                            <div>
                                <h1
                                    className={classNames(
                                        classes.infoSectionTitle,
                                        classes.infoSectionTitleDecorated
                                    )}
                                >
                                    Applied Learning for Better Processes!
                                </h1>
                                <p className={classes.infoSectionSubtitle}>
                                    Help yourself through our robust database of
                                    courses and learning materials to improve
                                    your business processes.
                                </p>
                            </div>
                            {/* <div>
                                <h1
                                    className={classNames(
                                        classes.infoSectionTitle,
                                        classes.infoSectionTitleDecorated
                                    )}
                                    style={{ marginTop: 40 }}
                                >
                                    Get Globally-Recognised Certification!
                                </h1>
                                <p className={classes.infoSectionSubtitle}>
                                    We have valuable experience in the
                                    Africancapacity-building industry, so our
                                    certificates are widely recognised and
                                    accepted across industries on the continent.
                                </p>
                                <img
                                    className={classes.infoSectionDecoration}
                                    src={require('../../assets/images/homepage-dots.svg')}
                                    alt=""
                                />
                            </div> */}
                        </div>
                        <div
                            className={classNames(
                                classes.infoSectionPane,
                                classes.pointList
                            )}
                        >
                            <div
                                className={classes.pointListItem}
                                style={{
                                    '--color': '#F87488',
                                    '--shadow': 'rgba(248,116,136,0.25)',
                                }}
                            >
                                <div className={classes.pointIconWrapper}></div>
                                <h5 className={classes.pointTitle}>
                                    Amazing Courses
                                </h5>
                                <div className={classes.pointDivider} />
                                <p className={classes.pointText}>
                                    We are focused on bite-sized learning, with
                                    carefully outlined, step-by-step
                                    methodologies, that are taught through 100%
                                    practical demonstrations to aid
                                    implementation.
                                </p>
                            </div>
                            <div
                                className={classes.pointListItem}
                                style={{
                                    '--color': '#6DC9C8',
                                    '--shadow': 'rgba(109,201,200,0.5)',
                                }}
                            >
                                <div className={classes.pointIconWrapper}></div>
                                <h5 className={classes.pointTitle}>
                                    Tools And Templates
                                </h5>
                                <div className={classes.pointDivider} />
                                <p className={classes.pointText}>
                                    Implementation is guaranteed through the
                                    resources we provide, in the form of
                                    templates, worksheets and other relevant
                                    material that are available for each course.
                                </p>
                            </div>
                            <div
                                className={classes.pointListItem}
                                style={{
                                    '--color': '#B887F8',
                                    '--shadow': 'rgba(184,135,248,0.3)',
                                }}
                            >
                                <div className={classes.pointIconWrapper}></div>
                                <h5 className={classes.pointTitle}>
                                    Unrelenting Support
                                </h5>
                                <div className={classes.pointDivider} />
                                <p className={classes.pointText}>
                                    Our backend support is designed to provide
                                    you with all the help you need by walking
                                    you through the learning process from start
                                    to finish.
                                </p>
                            </div>
                            <div
                                className={classes.pointListItem}
                                style={{
                                    '--color': '#FF9655',
                                    '--shadow': 'rgba(255,150,85,0.3)',
                                }}
                            >
                                <div className={classes.pointIconWrapper}></div>
                                <h5 className={classes.pointTitle}>
                                    New Courses Weekly
                                </h5>
                                <div className={classes.pointDivider} />
                                <p className={classes.pointText}>
                                    We have a team working tirelessly to create
                                    and turn out courses on a weekly basis, so
                                    you are never out of things to learn!
                                </p>
                            </div>
                        </div>
                    </div>
                    <div className={classes.infoSection}>
                        <h5 className={classes.infoSectionTitle}>
                            Our Courses
                        </h5>
                        <div className={classes.infoSectionDescription}>
                            <p className={classes.infoSectionSubtitle}>
                                Choose from a variety of flexible and affordable
                                online course options, and get your
                                implementation started.
                            </p>
                            <Link
                                to="/app/browse/courses"
                                className={classes.infoSectionLink}
                            >
                                Explore more courses
                                <ForwardIcon
                                    className={classes.infoSectionLinkIcon}
                                />
                            </Link>
                        </div>
                        <OurCourses />
                    </div>
                    <div
                        className={classNames(
                            classes.infoSection,
                            classes.infoSectionReducedMargin
                        )}
                    >
                        <h5 className={classes.infoSectionTitle}>
                            Onsite classes
                        </h5>
                        <div className={classes.infoSectionDescription}>
                            <p className={classes.infoSectionSubtitle}>
                                Experience in-depth learning live at our onsite
                                classes. Register now for a hands-on learning
                                process with our trainers.
                            </p>
                            <Link
                                to="/app/browse/classes"
                                className={classes.infoSectionLink}
                            >
                                Explore more classes
                                <ForwardIcon
                                    className={classes.infoSectionLinkIcon}
                                />
                            </Link>
                        </div>
                        <OurClasses />
                    </div>
                    {/* <PlanSection /> */}
                </div>
                <div className={gridClasses.container}>
                    <div
                        className={classNames(
                            classes.banner,
                            classes.curvedBanner
                        )}
                    >
                        <div
                            style={{ backgroundImage: `url(${Doodle})` }}
                            className={classes.curvedBannerBackground}
                        />
                        <img
                            className={classes.bannerImage}
                            src={ourStoryImage}
                            alt=""
                        />
                        <div
                            className={classNames(
                                gridClasses.container,
                                gridClasses.containerTransparent,
                                classes.bannerContainer
                            )}
                        >
                            <div className={classes.bannerText}>
                                <h5 className={classes.bannerTitle}>
                                    Upturn for Business
                                </h5>
                                <p className={classes.bannerSubtitle}>
                                    We are constantly reminded of the fact that
                                    businesses are drowned with trying to get
                                    their processes in order. This makes their
                                    creativity suffer, and they forget why
                                    they're in business in the first place.
                                    Upturn for Business was founded as a
                                    platform to shorten that gap, and help
                                    businesses implement faster, so they can
                                    focus on their creative side.
                                </p>
                                <Button
                                    className={classes.bannerLink}
                                    onClick={() => history.push('/business')}
                                >
                                    Learn More
                                    <ButtonIcon icon={<ForwardIcon />} />
                                </Button>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={gridClasses.container}>
                    <div
                        className={classNames(
                            classes.infoSection,
                            classes.infoSectionDual,
                            classes.infoSectionDualFlex
                        )}
                    >
                        <div className={classes.infoSectionPane}>
                            <h1 className={classes.infoSectionTitle}>Blog</h1>
                            <p className={classes.infoSectionSubtitle}>
                                Get more business insights, templates and tools
                                here.
                            </p>
                            <div className={classes.blogButtons}>
                                <button
                                    className={classes.blogButton}
                                    ref={prevButton}
                                >
                                    <LeftIcon
                                        className={classes.blogButtonIcon}
                                    />
                                </button>
                                <button
                                    className={classes.blogButton}
                                    ref={nextButton}
                                >
                                    <RightIcon
                                        className={classes.blogButtonIcon}
                                    />
                                </button>
                            </div>
                        </div>
                        <div className={classes.infoSectionPane}>
                            <Carousel
                                slideClassName={classes.blogSlide}
                                nextButton={nextButton}
                                prevButton={prevButton}
                            >
                                {isFetching
                                    ? [...Array(6)].map((_, idx) => (
                                          <CardLoader key={idx} />
                                      ))
                                    : posts.map(
                                          ({
                                              startdate,
                                              author,
                                              caption,
                                              thumbnail,
                                              postid,
                                          }) => (
                                              <BlogPostCard
                                                  title={caption}
                                                  imageUrl={thumbnail}
                                                  authorImage={author.dp}
                                                  author={`${String(
                                                      author.firstname || ''
                                                  )} ${String(
                                                      author.lastname || ''
                                                  )}`}
                                                  date={startdate}
                                                  postId={postid}
                                              />
                                          )
                                      )}
                            </Carousel>
                        </div>
                    </div>
                </div>
                <div
                    className={classes.banner}
                    style={{ background: `url(${GettingStarted})` }}
                >
                    {/* <div style={{backgroundImage: `url(${GettingStarted})`, width: "100%", height: "100%", left: 0, top: 0, position: "absolute"}} /> */}
                    <div
                        className={classNames(
                            gridClasses.container,
                            gridClasses.containerTransparent,
                            classes.bannerContainer
                        )}
                    >
                        <div className={classes.bannerText}>
                            <h5 className={classes.bannerTitle}>
                                Get Started. Start Implementing
                            </h5>
                            <p className={classes.bannerSubtitle}>
                                Take the bold step and delve into the learning
                                process now. We'll be waiting on the other side.
                            </p>
                        </div>
                        <Button
                            className={classes.bannerAction}
                            bold
                            to={'/app/auth/sign-up'}
                        >
                            Start learning
                        </Button>
                    </div>
                </div>
            </main>
            <Footer />
        </Fragment>
    )
}
